import { connect } from 'react-redux';
import {
  loadDataMaps,
  loadRecipeBuilderSamples,
  updateDataSamples,
  applyRecipe,
  recipeApplied,
  initSchemaEditor,
  resetSchemaEditor,
  updateInputSchema,
  resetRecipeGroups,
  clearFormError,
  getAllSchemaSpecs,
  setContextualSupport,
  unsetContextualSupport,
  addUserSettings,
  updateUserSettings,
} from '../../actions';

import { getSamplesRequestStatus, getImpersonatedUser } from '../../reducers/selectors';
import {
  GET_DATA_SET_REQUEST,
  GET_DATA_SAMPLES_REQUEST,
  GET_DATA_CHARACTERISTICS_REQUEST,
  GET_TRANSFORMED_SAMPLES_FAILURE,
  GET_USER_SETTINGS_REQUEST,
} from '../../constants/actionTypes';

import RecipeBuilder from './RecipeBuilder';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { userSettings },
    forms: { activeType: formType },
    schemaEditor: {
      dataSetId,
      fromSamples: { fromUpdatedAt, fromFlat, fromNested },
      toSamples: { toUpdatedAt, toFlat, toNested },
      fromSchema,
      toSchema,
      fromSamples,
      toSamples,
      isEmptyOutput,
    },
    recipeBuilder: { recipeGroups },
    samples,
    errors: { error },
    transforms: { reusableRecordTransforms },
    request,
  } = state;
  const transformsError = error && error.type === GET_TRANSFORMED_SAMPLES_FAILURE ? error : null;
  const characteristics = samples[dataSetId] && samples[dataSetId].characteristics;
  const isImpersonationMode = getImpersonatedUser(state) ? true : false;

  return {
    formType,
    userSettings,
    reusableRecordTransformsLoaded: !!reusableRecordTransforms.lastUpdated,
    recipeGroups,
    dataSetId,
    isImpersonationMode,
    samples: {
      id: dataSetId,
      fromUpdatedAt,
      fromFlat,
      fromNested,

      toUpdatedAt,
      toNested,
      toFlat,
    },
    fromSchema,
    toSchema,
    fromSamples,
    toSamples,
    isEmptyOutput,
    characteristics,
    isLoadingInSamples:
      !!request[GET_DATA_SAMPLES_REQUEST] || !!request[GET_DATA_CHARACTERISTICS_REQUEST],
    isLoadingSamples: getSamplesRequestStatus(state),
    isLoadingDataSet: !!request[GET_DATA_SET_REQUEST],
    transformsError,
    isLoadingUserSettings: !!request[GET_USER_SETTINGS_REQUEST],
  };
};

export default connect(mapStateToProps, {
  loadDataMaps,
  loadRecipeBuilderSamples,
  updateDataSamples,
  applyRecipe,
  recipeApplied,
  initSchemaEditor,
  resetSchemaEditor,
  updateInputSchema,
  resetRecipeGroups,
  clearFormError,
  getAllSchemaSpecs,
  setContextualSupport,
  unsetContextualSupport,
  addUserSettings,
  updateUserSettings,
})(RecipeBuilder);
